import { Home, StoryList, StoryEdit, StoryPreview, Participants } from './views'

export const routesConfig = (appName, displayName) => ([
  { path: `/${appName}/new`,          element: StoryEdit,     breadcrumb: 'New Story' },
  { path: `/${appName}/list`,         element: StoryList,     breadcrumb: 'Stories' },
  { path: `/${appName}/:slug/edit`,   element: StoryEdit,     breadcrumb: 'Edit' },
  { path: `/${appName}/deltagare`,    element: Participants,  breadcrumb: 'Externa deltagare' },
  { path: `/${appName}/:slug`,        element: StoryPreview,  breadcrumb: 'Story' },
  { path: `/${appName}/`,             element: Home,          breadcrumb: displayName },
])
